var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFosteringCharacter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_8",
    "data-name": "Group 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 78.783,
    height: 87.69,
    viewBox: "0 0 78.783 87.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    width: 78.783,
    height: 87.69,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M1.212,148.924A1.947,1.947,0,0,1,0,147.134c.074-13.846-.1-27.712.09-41.545a1.707,1.707,0,0,1,1.708-1.2c5.587.473,12.161-.611,17.631.027a5.2,5.2,0,0,1,4.14,3.071c8.876-2.2,23.552-7.9,24.391-18.591.193-2.459-.374-3.858,1-6.192a6.838,6.838,0,0,1,11.7,0c2.089,3.545.972,12.517.059,16.558-.394,1.743-1.036,3.405-1.458,5.136H72.887a8.778,8.778,0,0,1,2.812,1.127A6.8,6.8,0,0,1,74.354,117.6c-.17.239.6,1.5.725,1.9a6.776,6.776,0,0,1-4.15,8.371,14.344,14.344,0,0,0,.794,2.178,6.75,6.75,0,0,1-4.219,8.1c-.17.239.6,1.5.725,1.9a6.879,6.879,0,0,1-4.046,8.388l-1.486.484H39.576l-4-.364a89.555,89.555,0,0,1-12-2.724,5.489,5.489,0,0,1-3.865,3.089Zm54.263-44.558a33.632,33.632,0,0,0,2.2-7.3A40.113,40.113,0,0,0,58.2,85.686,3.441,3.441,0,0,0,52.605,83.6c-1.72,1.419-1.068,3.395-1.206,5.3-.928,12.917-16.591,19.355-27.387,22.023l.145,31.58c3.844.918,7.647,2.144,11.586,2.628,1.471.181,2.961.127,4.424.372,6.977-.465,14.705.6,21.593,0a3.433,3.433,0,0,0,.317-6.838c-1.775-.213-4.47.314-6.065-.1a1.718,1.718,0,0,1,.272-3.333c2.661-.407,8.1.63,10.3-.321a3.5,3.5,0,0,0,.823-5.683c-1.918-1.714-5.675-.343-7.967-.939a1.719,1.719,0,0,1,.272-3.333c2.661-.407,8.1.63,10.3-.321a3.509,3.509,0,0,0,.916-5.6c-1.9-1.831-5.739-.414-8.06-1.017a1.719,1.719,0,0,1,.272-3.333c2.6-.4,6.161.232,8.9,0a3.433,3.433,0,0,0,.317-6.838l-23.062-.059a1.718,1.718,0,0,1,.3-3.39c.952-.112,5.538.189,5.885-.025M3.439,145.5H19.281a1.94,1.94,0,0,0,1.289-1.623l-.085-34.861a1.991,1.991,0,0,0-1.2-1.194H3.439Z",
    transform: "translate(0 -61.234)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M232.927.039a1.713,1.713,0,0,1,2.1,1.586,55.216,55.216,0,0,1-.015,8.214,1.72,1.72,0,0,1-3.419-.156,55.221,55.221,0,0,1,.015-8.214,1.712,1.712,0,0,1,1.315-1.43",
    transform: "translate(-178.496 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M170.17,30.774a1.851,1.851,0,0,1,1.5.481,51.546,51.546,0,0,1,4.853,4.91c1.235,1.914-.607,3.678-2.524,2.353a51.573,51.573,0,0,1-4.885-4.877,1.753,1.753,0,0,1,1.061-2.866",
    transform: "translate(-130.121 -23.717)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M280.767,30.7a1.76,1.76,0,0,1,1.729,2.768,52.289,52.289,0,0,1-4.954,4.98,2.057,2.057,0,0,1-.762.435,1.709,1.709,0,0,1-1.975-2.487,52.8,52.8,0,0,1,4.719-4.872,4.279,4.279,0,0,1,1.243-.823",
    transform: "translate(-211.779 -23.645)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M143.643,94.021a51.509,51.509,0,0,1,7.628,0,1.722,1.722,0,0,1-.143,3.375,49.9,49.9,0,0,1-7.485-.029,1.723,1.723,0,0,1,0-3.346",
    transform: "translate(-109.765 -72.4)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M293.351,94.021a51.509,51.509,0,0,1,7.628,0,1.722,1.722,0,0,1-.143,3.375,49.9,49.9,0,0,1-7.485-.029,1.723,1.723,0,0,1,0-3.346",
    transform: "translate(-225.22 -72.4)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M60.8,263.511c1.257-.241,1.994.572,2.108,1.753.42,4.371-.323,9.425-.02,13.87a1.721,1.721,0,0,1-3.423-.323c-.416-4.328.332-9.314,0-13.714a1.716,1.716,0,0,1,1.33-1.586",
    transform: "translate(-45.76 -203.187)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M61.318,233.572a1.722,1.722,0,1,1,.627,3.385,1.722,1.722,0,0,1-.627-3.385",
    transform: "translate(-46.277 -180.098)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFosteringCharacter);
export default __webpack_public_path__ + "static/media/fostering_character.7282b793c075c2fa7084219a28feb26e.svg";
export { ForwardRef as ReactComponent };